<div class="item" (mouseenter)="playVideoFrame(ytb)" (mouseleave)="pauseVideoFrame(ytb)">
  <img [src]="card.imagen" class="img-carroussel video-off">
  <div class="img-carroussel video-on">
    <youtube-player #ytb videoId="{{card.url_item_extern}}" width="100%" height="100%"></youtube-player>
  </div>
</div>
